import { RefObject, useEffect, useRef, useState } from 'react';

import { bindAll } from 'bind-event-listener';

export const useOnHover = <T extends HTMLElement = HTMLElement>(): [boolean, RefObject<T>] => {
	const ref = useRef<T>(null);
	const [isHovered, setIsHovered] = useState(false);
	useEffect(() => {
		if (!ref || !ref.current) {
			return;
		}

		bindAll(ref.current, [
			{
				type: 'mouseover',
				listener: () => setIsHovered(true),
			},
			{
				type: 'focusin',
				listener: () => setIsHovered(true),
			},
			{
				type: 'mouseout',
				listener: () => setIsHovered(false),
			},
			{
				type: 'focusout',
				listener: () => setIsHovered(false),
			},
		]);
	}, [ref, isHovered]);

	return [isHovered, ref];
};
